<!-- User profile -->
<div class="user-profile" *ngIf="currentUser">
  <!-- User profile text-->
  <div class="profile-text">
    <h5>{{currentUser.screenName}}</h5>
    <h6>{{currentUser.storeName}}</h6>
  </div>
</div>
<!-- End User profile text-->

<!-- Sidebar Search -->
<div class="sidebar-search" *ngIf="currentUser">
  <div class="search-container">
    <i class="fas fa-search search-icon"></i>
    <input type="text" placeholder="Menüde ara..." [(ngModel)]="searchTerm" (input)="onSearchChange()" class="search-input" />
    <i class="fas fa-times clear-icon" *ngIf="searchTerm" (click)="clearSearch()"></i>
  </div>
  <div class="search-results" *ngIf="searchTerm && filteredResults.length > 0">
    <div class="search-result-item" *ngFor="let result of filteredResults" (click)="navigateToMenuItem(result)">
      <i class="fas fa-arrow-right result-icon"></i>
      <span class="result-text">
        <strong>{{result.category}}</strong> > {{result.menuItem}}
      </span>
    </div>
  </div>
</div>
<!-- End Sidebar Search -->

<!-- Simple Divider -->
<div class="sidebar-divider">
</div>

<!-- Sidebar navigation-->
<nav class="sidebar-nav">
  <ul id="sidebarnav" *ngIf="currentUser">
    <!-- First level menu -->
    <li [class.active]="showMenu === sidebarnavItem.title && sidebarnavItem.items.length === 0" [class.expanded]="showMenu === sidebarnavItem.title && sidebarnavItem.items.length > 0"
      *ngFor="let sidebarnavItem of currentUser.menuList" [routerLinkActive]="sidebarnavItem.items.length != 0 ? '' : 'active'">
      <div class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true">
        <i class="fas fa-star me-2"></i>
        {{sidebarnavItem.translateKey | translate}}
      </div>
      <a [skipLocationChange]="false" [routerLink]="sidebarnavItem.class === '' ? [sidebarnavItem.routerLink] : null" [ngClass]="[sidebarnavItem.class]" *ngIf="!sidebarnavItem.extralink;"
        (click)="addExpandClass(sidebarnavItem.title)">
        <i [ngClass]="[sidebarnavItem.icon]"></i>
        <span class="hide-menu">{{sidebarnavItem.translateKey | translate}}
          <span *ngIf="sidebarnavItem.label != '' " [ngClass]="[sidebarnavItem.labelClass]">{{sidebarnavItem.label}}</span>
        </span>
      </a>
      <!-- Second level menu -->
      <ul class="collapse" *ngIf="sidebarnavItem.items.length > 0" [ngClass]="{'in' : showMenu === sidebarnavItem.title }">
        <li *ngFor="let sidebarnavSubItem of sidebarnavItem.items" [class.active]="showSubMenu === sidebarnavSubItem.title" [routerLinkActive]="sidebarnavSubItem.items.length > 0 ? '' : 'active'">

          <a [skipLocationChange]="false" [routerLink]="sidebarnavSubItem.items.length > 0 ? null : [sidebarnavSubItem.routerLink]"
            [routerLinkActive]="sidebarnavSubItem.items.length > 0 ? '' : 'router-link-active'" [ngClass]="[sidebarnavSubItem.class ??'']" *ngIf="!sidebarnavSubItem.extralink;"
            (click)="addActiveClass(sidebarnavSubItem.title)">
            {{sidebarnavSubItem.translateKey | translate}}
          </a>
          <!-- Third level menu -->
          <ul class="collapse" *ngIf="sidebarnavSubItem.items.length > 0" [ngClass]="{'in' : showSubMenu === sidebarnavSubItem.title }">
            <li *ngFor="let sidebarnavSubsubItem of sidebarnavSubItem.items" routerLinkActive="active" [ngClass]="[sidebarnavSubsubItem.class]">
              <a [skipLocationChange]="false" [routerLink]="[sidebarnavSubsubItem.routerLink]" *ngIf="!sidebarnavSubsubItem.extralink;"
                [routerLinkActive]="sidebarnavSubsubItem.items.length > 0 ? '' : 'router-link-active'">
                {{sidebarnavSubsubItem.translateKey | translate}}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</nav>
<!-- End Sidebar navigation -->

<!-- Simple Footer -->
<!-- <div class="sidebar-footer" *ngIf="currentUser">
  <i class="fas fa-copyright me-2"></i>
  <span>2025 Aktif Müşteri</span>
</div> -->